export default __webpack_public_path__ + "f82c7f8fda21ecb02ae3f6fb961419c0.jpg";